<template>
  <el-dialog title="商品sku列表" :visible="showSkuDialog" @close="handleCloseDialog" width="80%">
    <div>
      <el-form :inline="true" :size="formSize" @submit.native.prevent="handleSearch">
        <el-form-item label="品牌名称">
          <el-select v-model="searchForm.brandid" clearable filterable placeholder="按品牌" style="width:100%;">
            <el-option v-for="(item, index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上架状态">
          <el-select v-model="searchForm.status" clearable filterable placeholder="请选择" style="width:100%;">
            <el-option label="已上架" value="0"></el-option>
            <el-option label="已下架" value="1"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="可用库存">
          <el-select v-model="searchForm.lastinventory" clearable filterable placeholder="请选择" style="width:100%;">
            <el-option label="大于0" value="1"></el-option>
            <el-option label="等于0" value="0"></el-option>
          </el-select>
        </el-form-item> -->


        <el-form-item>
          <el-input v-model="searchForm.key" placeholder="请输入商品名称/编号/条码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList">查询</el-button>
        </el-form-item>
        <el-form-item>
          <div>已选择：{{ selectedCount }}个商品SKU</div>
        </el-form-item>
      </el-form>
      <!-- 表格部分 -->
      <el-table :data="skus" style="width: 100%">
        <el-table-column prop="sku" label="SKUID"></el-table-column>
        <el-table-column prop="productInfo" label="商品信息" width="400px">
          <template slot-scope="scope">
            <div class="goodsInfo">
              <div class="left">
                <img :src="scope.row.img">
              </div>
              <div class="right">
                <div class="name">{{ scope.row.name }}</div>
                <div class="prop" style="margin-top: 10px;">{{ scope.row.property_name }} {{ scope.row.spec }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="brand_name" label="所属品牌"></el-table-column>
        <el-table-column prop="weight" label="重量（kg）"></el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>
        <el-table-column prop="property_price" label="批发价格"></el-table-column>
        <el-table-column prop="inventory" label="可用库存"></el-table-column>
        <el-table-column prop="status" label="上下架状态">
          <template slot-scope="scope">
            {{ scope.row.status == 1 ? '已下架' : '已上架' }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" :type="isSelected(scope.row) ? 'primary' : ''" @click="toggleSelectSku(scope.row)"
              class="selectBtn" :style="{ backgroundColor: isSelected(scope.row) ? '#409EFF' : '' }">
              {{ isSelected(scope.row) ? '已选择' : '选择' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页部分 -->
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="searchForm.p" :page-sizes="[5, 10, 20]" :page-size="searchForm.rollpage"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSave">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  data() {
    return {
      loading: false,
      showSkuDialog: false,
      formSize: 'small',
      searchForm: {
        act: 'get_sku_list',
        key: '',
        brandid: '',
        status: '0',
        // lastinventory: '',
        p: 1,
        rollpage: 10
      },
      total: 0,
      selectedCount: 0,
      skus: [],
      selectedSkus: [],
      currentPage: 1,
      pageSize: 5,
      brandlists:[],
    };
  },
  methods: {
    //获取品牌
    getBrand(){
      var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    getList() {
      this.loading = true
      this.$axios({
        url: this.GLOBAL.domain + 'Combination/index',
        method: 'GET',
        params: this.searchForm
      })
        .then(res => {
          this.skus = res.Data
          this.total = +res.count || 0
        })
        .finally(() => {
          this.loading = false
        });
    },
    handleSearch() {
      // 这里可以添加实际的搜索逻辑
    },
    toggleSelectSku(row) {
      const index = this.selectedSkus.findIndex(sku => sku.propertyid === row.propertyid);
      if (index > -1) {
        // 如果已经选中，则取消选择
        this.selectedSkus.splice(index, 1);
      } else {
        // 如果未选中，则添加到选中列表
        this.selectedSkus.push(row);
      }
      this.selectedCount = this.selectedSkus.length;
    },
    isSelected(row) {
      return this.selectedSkus.some(sku => sku.propertyid === row.propertyid);
    },
    handleCloseDialog() {
      this.resetData();
    },
    handleCancel() {
      this.showSkuDialog = false;
    },
    handleSave() {
      this.$emit('chooseSku', this.selectedSkus);
      this.showSkuDialog = false;
    },
    handleSizeChange(val) {
      this.searchForm.rollpage = val;
      this.searchForm.p = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchForm.p = val;
      this.getList();
    },

    initDialog(selectedSkus = []) {
      this.getBrand()
      this.getList()
      this.showSkuDialog = true;
      this.selectedSkus = JSON.parse(JSON.stringify(selectedSkus));
      this.selectedCount = selectedSkus.length;
    },
    resetData() {
      this.searchForm = {
        act: 'get_sku_list',
        key: '',
        brandid: '',
        status: '0',
        // lastinventory: '',
        p: 1,
        rollpage: 10
      }
      this.selectedSkus = [];
      this.selectedCount = 0;
      this.currentPage = 1;
      this.pageSize = 5;
      this.$nextTick(() => {
        this.showSkuDialog = false;
      });
    }
  }
};
</script>

<style scoped>
.block {
  text-align: left;
  margin-top: 10px;
}

.selectBtn {
  width: 70px;
}

.goodsInfo {
  display: flex;
  align-items: center;
}

.goodsInfo .left {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  margin-right: 10px;
}

.goodsInfo .left img {
  width: 100%;
  height: 100%;
}

.goodsInfo .prop {
  color: #a1a1a1;
}
</style>


// WEBPACK FOOTER //
// src/components/mall/CombinationSku.vue